const BOOK_CONSULTATION_URL = 'https://meetings-eu1.hubspot.com/he-demo/book-a-demo';

export default function bookConsultationUrl(email?: string): string {
  return `${BOOK_CONSULTATION_URL}?email=${encodeURIComponent(email ?? '')}`;
}
